"use strict";

require("@emotion/core");